import { all, fork } from 'redux-saga/effects'
import inductionSaga from './induction-saga'

export default function* flowResourcesSagas() {
  yield all([fork(inductionSaga)])
}
